import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import listMixin from '@/components/niotaClassic/listMixin';
import { mapState } from 'vuex';
import { isCopyToClipboardSupported, copyToClipboard as _copyToClipboard } from '@/utils/vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  page: 1,
  sortBy: ['id'],
  sortDesc: [false],
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicApplicationsLinkedDevicesList',
  mixins: [listMixin],
  props: {
    accountIds: {
      type: Array,
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      lastSearch: '',
      deviceTypes: [],
      applications: [],
      tableOptions: defaultTableOptions,
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      deviceUpdateDialog: false,
      selectedRows: [],
      selected: [],
      deviceFormDialog: false,
      editAllFormDialog: false,
      createDeviceDialog: false,
      editedItem: {
        applicationId: this.$route.params.applicationId
      },
      deleteFromActility: false,
      isActility: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    actionButtons: function actionButtons() {
      return [{
        icon: 'fal fa-plus',
        title: this.$i18n_t('NiotaClassic.Applications.createDevice'),
        action: 'createDevice',
        valid: this.isIotHubManager && !this.disabled && this.hasManagePermission,
        tooltip: this.$i18n_t('Common.addNew')
      }, {
        icon: 'fal fa-edit',
        title: this.$i18n_t('Common.edit'),
        action: 'showEditAllDialog',
        valid: this.isIotHubManager && this.selectedRows && this.selectedRows.length > 0
      }];
    },
    tableHeaders: function tableHeaders() {
      return [{
        text: this.$i18n_t('NiotaClassic.Common.table.id'),
        value: 'id',
        align: 'right'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.title'),
        value: 'title'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.table.eui'),
        value: 'eui'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.originator'),
        sortable: false,
        align: 'left',
        value: 'originator_title'
      }, // {
      //   text: this.$i18n_t('NiotaClassic.Applications.table.threshold'),
      //   sortable: false,
      //   value: 'properties.minimum_packets_threshold',
      // },
      {
        text: this.$i18n_t('NiotaClassic.Applications.table.operationalStatus'),
        sortable: false,
        value: 'operationalStatus'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        value: 'createdAt'
      }].concat(_toConsumableArray(this.isIotHubManager ? [{
        text: '',
        sortable: false,
        value: 'actions',
        width: 80
      }] : []));
    }
  }),
  watch: {
    accountIds: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList(true);
    }, 500)
  },
  mounted: function mounted() {
    this.fetchList(true);
    this.deviceTypeFetchPlain();
    this.applicationsFetchPlain();
  },
  methods: {
    fetchList: function fetchList(fromStart) {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var trimmedSearch = (this.searchItem || '').trim();

      if (this.lastSearch !== trimmedSearch || fromStart) {
        this.lastSearch = trimmedSearch;
        this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
          page: 1
        });
      }

      var _this$tableOptions = this.tableOptions,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = Math.max(1, page || 1);
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      var promise = undefined;

      if (trimmedSearch) {
        promise = NiotaClassicApiService.applicationDevicesFind(this.$route.params.applicationId, trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
      } else {
        promise = NiotaClassicApiService.applicationDevices(this.$route.params.applicationId, usedPage, usedItemsPerPage, sortItem, sortDirection);
      }

      promise.then(function (res) {
        _this.list = res.data.devices;
        _this.serverItemsLength = res.pagination.itemCount;
      }).catch(function (error) {
        console.error('Error fetching application devices', error);
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    refreshList: function refreshList() {
      this.selectedRows = [];
      this.fetchList(true);
    },
    deletePromise: function deletePromise() {
      return NiotaClassicApiService.applicationsDelete(this.selectedItem.id);
    },
    viewDevice: function viewDevice(item) {
      this.$router.push({
        path: "/niota-classic/devices/".concat(item.id, "/details")
      });
    },
    rowSelectUpdate: function rowSelectUpdate(rows) {
      this.selectedRows = rows;
    },
    getSelectedRows: function getSelectedRows(rows) {
      this.selectedRows = rows;
    },
    editAll: function editAll() {
      this.editAllFormDialog = true;
    },
    closeEditAllForm: function closeEditAllForm() {
      this.editAllFormDialog = false;
    },
    isCopySupported: function isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard: function copyToClipboard(event, copyValue) {
      event.stopPropagation();

      _copyToClipboard(copyValue);
    },
    openDeviceEditForm: function openDeviceEditForm() {
      this.deviceEditItem = null;
      this.deviceEditDialog = true;
    },
    editItem: function editItem() {
      this.openDeviceEditForm();
    },
    toggleEditDeviceDialog: function toggleEditDeviceDialog() {
      this.deviceFormDialog = !this.deviceFormDialog;
    },
    toggleEditAllDialog: function toggleEditAllDialog() {
      this.deviceUpdateDialog = !this.deviceUpdateDialog;
    },
    toggleCreateDeviceDialog: function toggleCreateDeviceDialog() {
      this.createDeviceDialog = !this.createDeviceDialog;
    },
    deviceTypeFetchPlain: function deviceTypeFetchPlain() {
      var _this2 = this;

      NiotaClassicApiService.deviceTypeFetchPlain().then(function (res) {
        _this2.deviceTypes = res.data.devicetypes;
      }).catch(function () {
        _this2.deviceTypes = [];

        _this2.$snack(_this2.$i18n_t('NiotaClassic.Applications.form.errorFindingDeviceTypes'), 'error');
      });
    },
    applicationsFetchPlain: function applicationsFetchPlain() {
      var _this3 = this;

      NiotaClassicApiService.applicationsFetchPlain().then(function (res) {
        _this3.applications = res.data.applications;
      }).catch(function () {
        _this3.applications = [];

        _this3.$snack(_this3.$i18n_t('NiotaClassic.Applications.form.errorFindingApplications'), 'error');
      });
    },
    editDevice: function editDevice(device) {
      this.editedDevice = device;
      this.deviceFormDialog = true;
    },
    showDeletePrompt: function showDeletePrompt(item) {
      this.selectedItem = cloneDeep(item);
      this.isActility = (get(this.selectedItem, 'originator.type') || '').toLowerCase() === 'actility';
      this.deletePrompt = true;
    },

    /** closeDeletePrompt in listMixin */
    deleteFromRemote: function deleteFromRemote(remove) {
      this.deleteFromActility = remove;
    },
    deleteDevice: function deleteDevice() {
      var _this4 = this;

      var deletePromise = null;

      if (this.deleteFromActility) {
        deletePromise = NiotaClassicApiService.deviceDeleteFromActility(this.selectedItem.id);
      } else {
        deletePromise = NiotaClassicApiService.deviceDelete(this.selectedItem);
      }

      deletePromise.then(function () {
        _this4.selectedItem == null;

        _this4.$snack(_this4.$i18n_t('NiotaClassic.Applications.snacks.deviceDeleteSuccess'), 'success');

        _this4.refreshList();
      }).catch(function () {
        _this4.$snack(_this4.$i18n_t('NiotaClassic.Applications.snacks.deviceDeleteFailed'), 'error');
      }).finally(function () {
        _this4.deletePrompt = false;
      });
    },
    getOperationalStatus: function getOperationalStatus(device) {
      var allStatus = [this.$i18n_t('NiotaClassic.Devices.form.unset'), this.$i18n_t('NiotaClassic.Devices.form.inTransit'), this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'), this.$i18n_t('NiotaClassic.Devices.form.inOperation'), this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'), this.$i18n_t('NiotaClassic.Devices.form.decommissioned')];
      return allStatus[get(device, 'properties.operational_status.value')] || allStatus[3];
    }
  }
};